import { gql } from "@apollo/client";

export const UpdateTicket = gql`
  mutation UpdateTicket(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: UpdateTicketDetails!
    $ticketID: ID!
  ) {
    UpdateTicket(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
      ticketID: $ticketID
    ) {
      id
    }
  }
`;
